enum DirectionKind {
  JS = 'js',
  QA = 'qa',
}

export { DirectionKind };
